import { damp, transform } from '@studiometa/js-toolkit/utils';
import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * LargeText class.
 */
export default class LargeText extends withBreakpointObserver(Base) {
  /**
   * Config.
   */
  static config = {
    name: 'LargeText',
    refs: ['target'],
    options: {
      pauseOnHover: Boolean,
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s m l xl 2xl 3xl',
      },
    },
  };

  /**
   * Translate X.
   * @type {number}
   */
  x = 0;

  /**
   * Transform values.
   */
  transform = {
    x: 0,
  };

  /**
   * Target width.
   * @type {number}
   */
  width = 0;

  /**
   * Set width on mount.
   * @returns {void}
   */
  mounted() {
    this.width = this.$refs.target.clientWidth;
  }

  /**
   * Set transform back to 0 on destroy
   */
  destroyed() {
    transform(this.$refs.target, { x: 0 });
  }

  /**
   * Set width on resize.
   * @returns {void}
   */
  resized() {
    this.width = this.$refs.target.clientWidth;
  }

  /**
   * On mouse enter pause large text
   */
  onMouseenter() {
    this.hasMouse = true;
  }

  /**
   * On mouse enter pause large text
   */
  onMouseleave() {
    this.hasMouse = false;
  }

  /**
   * Update values on raf.
   * @returns {void}
   */
  ticked() {
    this.x -= this.$options.pauseOnHover && this.hasMouse ? 0 : 1;

    this.transform.x = damp(this.x, this.transform.x, 0.25);

    if (this.x <= this.width * -1) {
      this.x = 0;
      this.transform.x += this.width;
    } else if (this.$options.sensitivity < 0 && this.x >= this.width) {
      this.x = 0;
      this.transform.x -= this.width;
    }

    transform(this.$refs.target, this.transform);
  }
}
